var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 235,
    viewBox: "0 0 421 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2755_30471)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 395,
    height: 95.4106,
    rx: 11.2857,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5298,
    y: 6.52976,
    width: 395.94,
    height: 96.3511,
    rx: 11.756,
    stroke: "#F7F7F7",
    strokeWidth: 0.940476
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7109 80.9407H74.6643L79.554 69.2903H40.7109V80.9407Z",
    fill: "#0098F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6641 66.9619L82.5756 61.1824L87.6982 48.6921L40.6641 55.2533V66.9619Z",
    fill: "#0098F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6641 52.9583L91.5567 40.0023L97.2863 26.0816L40.6641 40.8754V52.9583Z",
    fill: "#0099FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.084 59.0868H133.252L136.936 50.3636H122.084V44.318H139.489L143.439 34.996L143.472 34.9128H111.141V74.8203H143.522V65.4152H122.084V59.0868Z",
    fill: "#010100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261.48 38.6464C258.494 36.16 254.453 34.9126 249.363 34.9126H232.258V74.8284H243.318V63.4275H248.798C253.929 63.4275 258.07 62.1718 261.23 59.6687C264.382 57.1574 265.962 53.6231 265.962 49.0661C265.953 44.6005 264.457 41.1328 261.48 38.6464ZM253.205 53.3238C252.083 54.2718 250.536 54.7541 248.557 54.7541H243.31V44.2013H248.499C250.511 44.2013 252.083 44.6504 253.205 45.5402C254.328 46.43 254.885 47.7356 254.885 49.4486C254.893 51.0868 254.328 52.3758 253.205 53.3238Z",
    fill: "#010100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280.861 34.9126H269.801V74.8201H294.274L298.374 65.1322H280.861V34.9126Z",
    fill: "#010100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.216 34.6215L302.938 68.4002L300.219 74.82H303.936H311.853L314.705 67.6934H330.097L333.008 74.82H344.875L327.877 34.6215H317.216ZM317.948 59.0865L322.455 47.7355L326.904 59.0865H317.948Z",
    fill: "#010100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M367.217 34.9126L358.943 49.4486L350.735 34.9126H338.137L353.305 59.8849V74.8201H364.415V59.7103L379.591 34.9126H367.217Z",
    fill: "#010100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.186 34.9126L167.114 60.1677L158.05 34.9126H145.676L161.875 75.1111H172.137L188.327 34.9126H176.186Z",
    fill: "#010100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.033 34.2059C195.582 34.2059 186.293 43.4946 186.293 54.9455C186.293 66.3963 195.582 75.685 207.033 75.685C218.483 75.685 227.772 66.3963 227.772 54.9455C227.772 43.4946 218.483 34.2059 207.033 34.2059ZM207.033 65.8308C201.02 65.8308 196.156 60.9578 196.156 54.9538C196.156 48.9414 201.029 44.0767 207.033 44.0767C213.045 44.0767 217.91 48.9498 217.91 54.9538C217.91 60.9578 213.037 65.8308 207.033 65.8308Z",
    fill: "#010100"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2755_30471)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 122.411,
    width: 395,
    height: 95.4106,
    rx: 11.2857,
    fill: "#090A0B"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M380.328 122.41H396.711C402.944 122.41 407.997 127.463 407.997 133.696V150.08H380.328V122.41Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M13 133.696C13 127.463 18.0528 122.411 24.2857 122.411H40.6691V150.08H13V133.696Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M380.328 190.152H407.997V206.535C407.997 212.768 402.944 217.821 396.711 217.821H380.328V190.152Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M13 190.152H40.6691V217.821H24.2857C18.0528 217.821 13 212.768 13 206.535V190.152Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3203 195.925H75.2737L80.1634 184.275H41.3203V195.925Z",
    fill: "#0098F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2734 181.946L83.1767 176.167L88.3075 163.677L41.2734 170.238V181.946Z",
    fill: "#0098F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2734 167.943L92.1577 154.987L97.8956 141.066L41.2734 155.86V167.943Z",
    fill: "#0099FA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.69 174.071H133.85L137.542 165.348H122.69V159.303H140.095L144.037 149.981L144.078 149.889H111.738V189.805H144.128V180.4H122.69V174.071Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M262.093 153.63C259.107 151.144 255.066 149.897 249.977 149.897H232.871V189.812H243.931V178.412H249.411C254.542 178.412 258.683 177.156 261.843 174.653C264.995 172.141 266.575 168.607 266.575 164.05C266.575 159.585 265.078 156.117 262.093 153.63ZM253.827 168.308C252.704 169.256 251.158 169.738 249.178 169.738H243.931V159.185H249.12C251.133 159.185 252.704 159.634 253.827 160.524C254.95 161.414 255.507 162.72 255.507 164.433C255.507 166.071 254.95 167.36 253.827 168.308Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M281.47 149.888H270.418V189.804H294.891L298.991 180.116H281.47V149.888Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M317.822 149.606L303.543 183.384L300.824 189.804H304.541H312.458L315.31 182.677H330.703L333.613 189.804H345.48L328.483 149.606H317.822ZM318.562 174.071L323.069 162.72L327.518 174.071H318.562Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M367.826 149.888L359.561 164.433L351.353 149.888H338.746L353.914 174.869V189.804H365.032V174.694L380.2 149.888H367.826Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.795 149.888L167.731 175.152L158.667 149.888H146.293L162.484 190.087H172.754L188.945 149.888H176.795Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M207.638 149.19C196.187 149.19 186.898 158.479 186.898 169.93C186.898 181.38 196.187 190.669 207.638 190.669C219.089 190.669 228.378 181.38 228.378 169.93C228.378 158.479 219.097 149.19 207.638 149.19ZM207.638 180.807C201.626 180.807 196.761 175.934 196.761 169.93C196.761 163.917 201.634 159.052 207.638 159.052C213.65 159.052 218.515 163.926 218.515 169.93C218.523 175.942 213.65 180.807 207.638 180.807Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M31.5377 140.261H35.7937V141.227H30.0117V140.289C32.9051 138.105 34.3517 136.285 34.3517 134.829C34.3517 134.25 34.1837 133.807 33.8477 133.499C33.5117 133.182 33.0591 133.023 32.4897 133.023C31.7524 133.023 31.0244 133.298 30.3057 133.849V132.743C30.9684 132.23 31.7291 131.973 32.5877 131.973C33.4091 131.973 34.0997 132.211 34.6597 132.687C35.2197 133.163 35.4997 133.84 35.4997 134.717C35.4997 136.369 34.1791 138.217 31.5377 140.261Z",
    fill: "#A9AEB4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.707 142.655L28.803 131.329H29.937L24.827 142.655H23.707Z",
    fill: "#A9AEB4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.1081 137.601L23.4881 141.227H22.2141L20.4921 138.427L18.7141 141.227H17.4961L19.8761 137.587L17.6361 134.115H18.9101L20.5201 136.775L22.1441 134.115H23.4041L21.1081 137.601Z",
    fill: "#A9AEB4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M398.87 140.261H403.126V141.227H397.344V140.289C400.237 138.105 401.684 136.285 401.684 134.829C401.684 134.25 401.516 133.807 401.18 133.499C400.844 133.182 400.391 133.023 399.822 133.023C399.084 133.023 398.356 133.298 397.638 133.849V132.743C398.3 132.23 399.061 131.973 399.92 131.973C400.741 131.973 401.432 132.211 401.992 132.687C402.552 133.163 402.832 133.84 402.832 134.717C402.832 136.369 401.511 138.217 398.87 140.261Z",
    fill: "#A9AEB4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M391.039 142.655L396.135 131.329H397.269L392.159 142.655H391.039Z",
    fill: "#A9AEB4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M388.44 137.601L390.82 141.227H389.546L387.824 138.427L386.046 141.227H384.828L387.208 137.587L384.968 134.115H386.242L387.852 136.775L389.476 134.115H390.736L388.44 137.601Z",
    fill: "#A9AEB4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M31.5377 206.094H35.7937V207.06H30.0117V206.122C32.9051 203.938 34.3517 202.118 34.3517 200.662C34.3517 200.084 34.1837 199.64 33.8477 199.332C33.5117 199.015 33.0591 198.856 32.4897 198.856C31.7524 198.856 31.0244 199.132 30.3057 199.682V198.576C30.9684 198.063 31.7291 197.806 32.5877 197.806C33.4091 197.806 34.0997 198.044 34.6597 198.52C35.2197 198.996 35.4997 199.673 35.4997 200.55C35.4997 202.202 34.1791 204.05 31.5377 206.094Z",
    fill: "#A9AEB4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.707 208.488L28.803 197.162H29.937L24.827 208.488H23.707Z",
    fill: "#A9AEB4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.1081 203.434L23.4881 207.06H22.2141L20.4921 204.26L18.7141 207.06H17.4961L19.8761 203.42L17.6361 199.948H18.9101L20.5201 202.608L22.1441 199.948H23.4041L21.1081 203.434Z",
    fill: "#A9AEB4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M398.87 206.094H403.126V207.06H397.344V206.122C400.237 203.938 401.684 202.118 401.684 200.662C401.684 200.084 401.516 199.64 401.18 199.332C400.844 199.015 400.391 198.856 399.822 198.856C399.084 198.856 398.356 199.132 397.638 199.682V198.576C398.3 198.063 399.061 197.806 399.92 197.806C400.741 197.806 401.432 198.044 401.992 198.52C402.552 198.996 402.832 199.673 402.832 200.55C402.832 202.202 401.511 204.05 398.87 206.094Z",
    fill: "#A9AEB4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M391.039 208.488L396.135 197.162H397.269L392.159 208.488H391.039Z",
    fill: "#A9AEB4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M388.44 203.434L390.82 207.06H389.546L387.824 204.26L386.046 207.06H384.828L387.208 203.42L384.968 199.948H386.242L387.852 202.608L389.476 199.948H390.736L388.44 203.434Z",
    fill: "#A9AEB4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M395.901 170.995L398.281 174.621H397.007L395.285 171.821L393.507 174.621H392.289L394.669 170.981L392.429 167.509H393.703L395.313 170.169L396.937 167.509H398.197L395.901 170.995Z",
    fill: "#A9AEB4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M27.6159 170.995L29.9959 174.621H28.7219L26.9999 171.821L25.2219 174.621H24.0039L26.3839 170.981L24.1439 167.509H25.4179L27.0279 170.169L28.6519 167.509H29.9119L27.6159 170.995Z",
    fill: "#A9AEB4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 149.125,
    width: 395,
    height: 0.954106,
    fill: "#888B8D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 190.152,
    width: 395,
    height: 0.954106,
    fill: "#888B8D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 381.285,
    y: 122.41,
    width: 95.4106,
    height: 0.954102,
    transform: "rotate(90 381.285 122.41)",
    fill: "#888B8D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6211,
    y: 122.41,
    width: 95.4106,
    height: 0.954102,
    transform: "rotate(90 41.6211 122.41)",
    fill: "#888B8D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2755_30471",
    x: 0.77288,
    y: 0.416667,
    width: 419.454,
    height: 119.863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.64286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.64286
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2755_30471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2755_30471",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2755_30471",
    x: 1.71429,
    y: 116.768,
    width: 417.571,
    height: 117.982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.64286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.64286
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2755_30471"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2755_30471",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontal);
export default __webpack_public_path__ + "static/media/horizontal.38790c8f087904754ebad807f4e3bcde.svg";
export { ForwardRef as ReactComponent };